var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-list"},[(!_vm.isLoaded)?_c('ChatLoader'):_vm._e(),(_vm.isLoaded)?_c('v-list',{attrs:{"three-line":""}},_vm._l((_vm.chats),function(chat){return _c('Chat',{key:chat.id,attrs:{"chat":chat}})}),1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }